export const statusColors = {
  ACTIVE: 'bg-green-200 text-green-800',
  SUBMITTED: 'bg-blue-100 text-blue-800',
  DRAFT: 'bg-yellow-100 text-yellow-800',
  Completed: 'bg-gray-100 text-gray-700',
  DELETED: 'bg-gray-300 text-gray-700',
  CANCELLED: 'bg-red-100 text-red-800',
  // fallback is already handled with || 'bg-gray-100 text-gray-700'
};